import { getDie } from './dice';
import { paintCoreDieFaceSkin } from './coreDieAppearance';

export const paintDieFaceSkin = (context, width, height, dieType, color) => {
  if (!dieType) return;
  if (dieType.startsWith('core:')) {
    paintCoreDieFaceSkin(context, width, height, dieType.slice(5));
    return;
  }

  const die = getDie(dieType);
  const polished = die.id === 'chaos';
  const inset = width * 0.018;
  const corner = width * 0.09;

  // Share each die's finish and signature mark across every 3D scene.
  const faceGradient = context.createLinearGradient(0, 0, width, height);
  if (polished) {
    faceGradient.addColorStop(0, '#7b00ff6b');
    faceGradient.addColorStop(0.18, '#2a1939');
    faceGradient.addColorStop(0.52, '#130e20');
    faceGradient.addColorStop(0.8, '#251932');
    faceGradient.addColorStop(1, '#b00000ff');
  } else {
    faceGradient.addColorStop(0, die.body);
    faceGradient.addColorStop(1, '#0c1020');
  }
  context.fillStyle = faceGradient;
  context.fillRect(0, 0, width, height);

  context.save();
  if (polished) {
    const metal = context.createLinearGradient(0, 0, width, height);
    metal.addColorStop(0, '#d6f5ffff');
    metal.addColorStop(0.28, '#bda58c');
    metal.addColorStop(0.52, '#796782');
    metal.addColorStop(0.8, '#d5bfa1');
    metal.addColorStop(1, '#7178bbff');
    context.strokeStyle = metal;
    context.shadowBlur = 0;
  } else {
    context.strokeStyle = color;
  }
  context.lineWidth = polished ? width * 0.009 : Math.max(5, width * 0.03);
  context.globalAlpha = 1;
  context.beginPath();
  context.moveTo(inset + corner, inset);
  context.lineTo(width - inset - corner, inset);
  context.quadraticCurveTo(width - inset, inset, width - inset, inset + corner);
  context.lineTo(width - inset, height - inset - corner);
  context.quadraticCurveTo(
    width - inset,
    height - inset,
    width - inset - corner,
    height - inset
  );
  context.lineTo(inset + corner, height - inset);
  context.quadraticCurveTo(
    inset,
    height - inset,
    inset,
    height - inset - corner
  );
  context.lineTo(inset, inset + corner);
  context.quadraticCurveTo(inset, inset, inset + corner, inset);
  context.stroke();

  context.globalAlpha = polished ? 0.65 : dieType === 'rupture' ? 0.5 : 0.3;
  context.lineWidth = polished ? width * 0.003 : Math.max(4, width * 0.03);
  context.beginPath();
  if (polished) {
    // Fine champagne inlays leave an open face around the engraved glyph.
    for (const y of [height * 0.105, height * 0.895]) {
      context.moveTo(width * 0.28, y);
      context.lineTo(width * 0.44, y);
      context.moveTo(width * 0.56, y);
      context.lineTo(width * 0.72, y);
      context.moveTo(width * 0.5, y - height * 0.012);
      context.lineTo(width * 0.512, y);
      context.lineTo(width * 0.5, y + height * 0.012);
      context.lineTo(width * 0.488, y);
      context.closePath();
    }
  } else if (dieType === 'rupture') {
    context.moveTo(width * 0.12, height * 0.34);
    context.lineTo(width * 0.38, height * 0.05);
    context.moveTo(width * 0.61, height * 0.96);
    context.lineTo(width * 0.9, height * 0.63);
  } else if (dieType === 'aegis') {
    context.moveTo(width * 0.18, height * 0.12);
    context.lineTo(width * 0.82, height * 0.12);
    context.lineTo(width * 0.82, height * 0.61);
    context.quadraticCurveTo(
      width * 0.8,
      height * 0.82,
      width * 0.5,
      height * 0.93
    );
    context.quadraticCurveTo(
      width * 0.2,
      height * 0.82,
      width * 0.18,
      height * 0.61
    );
    context.closePath();
  } else if (dieType === 'equinox') {
    context.arc(width / 2, height / 2, width * 0.38, 0, Math.PI * 2);
  }
  context.stroke();
  context.restore();
};

export const paintDieFace = (context, width, height, value, color, dieType) => {
  const scale = width / 512;
  context.clearRect(0, 0, width, height);
  paintDieFaceSkin(context, width, height, dieType, color);
  context.textAlign = 'center';
  context.textBaseline = 'middle';
  if (dieType === 'chaos') {
    context.save();
    context.font =
      value === '?'
        ? `600 ${234 * scale}px Georgia, serif`
        : `800 ${224 * scale}px monospace`;
    const engraving = context.createLinearGradient(
      0,
      height * 0.25,
      0,
      height * 0.75
    );
    engraving.addColorStop(0, '#fff9ed');
    engraving.addColorStop(0.4, '#f0e1c9');
    engraving.addColorStop(0.72, '#d2bca9');
    engraving.addColorStop(1, '#c99898ff');
    context.fillStyle = engraving;
    context.shadowColor = '#ad82e3';
    context.shadowBlur = 7 * scale;
    context.fillText(value, width / 2, height / 2);
    context.restore();
    return;
  }
  context.font = `900 ${224 * scale}px monospace`;
  context.shadowColor = color;
  context.shadowBlur = 28 * scale;
  context.fillStyle = color;
  context.fillText(value, width / 2, height / 2);
  context.shadowBlur = 6 * scale;
  context.lineWidth = 5 * scale;
  context.strokeStyle = '#ffffffcc';
  context.strokeText(value, width / 2, height / 2);
};
